
require("hammerjs");

import MouseFollower from "mouse-follower";
import "mouse-follower/src/scss/index.scss";
import gsap from "gsap";
import LazyLoad from "vanilla-lazyload";

export default class imageMap {
    constructor() {
        
        MouseFollower.registerGSAP(gsap);

        const cursor = new MouseFollower({
            stateDetection: {
                'base': '.js-mark-base',
                'object': '.js-mark-object',
            }
        });


        // MAP
        let maps = document.querySelector(".js-maps");

        if(!maps) {
            return;
        }


        let title = maps.querySelector('.js-title');
        let text = maps.querySelector('.js-text');
        let map = maps.querySelector('.js-map');
        const animSpeed = 0.5;


        if(!maps || !title || !title || !map) {
            return;
        }

        // ZOOMAGE
        /*
        const map1 = map.querySelector(".hns-map__layer-1-control");
        var mc = new Hammer.Manager(map1);
        var pinch = new Hammer.Pinch();
        var pan = new Hammer.Pan();

        mc.add([pinch, pan]);
        let oldDeltaX = 0; 
        let oldDeltaY = 0;
        mc.on("pan", function(ev) {
            if(ev.pointerType != "touch") {
                return;
            }
            //console.log( ev );
            map1.style.transform = "translate("+ ev.deltaX+"px, "+ ev.deltaY+"px)";
        });

        mc.on("pinch", function(ev) {
            //console.log( ev );
        });
        */

        // Уровень 1
        for(let mark of map.querySelectorAll(".mark")) {

            mark.addEventListener('mouseenter', () => {

                let currentMap = maps.querySelector( "." + mark.dataset.map);
                title.innerHTML = currentMap.dataset.title;
                text.innerHTML = currentMap.dataset.text;
                //cursor.show();
                cursor.setText('Приблизить');
            });

            mark.addEventListener('mouseout', () => {
                //cursor.hide();
                cursor.removeText();
            });

            mark.addEventListener('click', () => {
                
                for(let oldMap of maps.querySelectorAll(".hns-map")) {
                    if(oldMap.classList.contains('hns-map_active')) {
                        gsap.fromTo(
                            oldMap, 
                            {opacity:1, scale: 1}, 
                            {opacity:0, duration: animSpeed, delay: 0, scale: 4, onComplete:() => {
                                oldMap.classList.remove('hns-map_active');
                                oldMap.classList.add('hns-map_hide');
                            }}
                        );
                    }
                }

                // Смена слоя
                let more_map = mark.dataset.map;
                let newMap = maps.querySelector( "." + more_map);
                newMap.classList.add('hns-map_active');

                gsap.fromTo(
                    newMap, 
                    { opacity:0, scale: 0, left:  newMap.dataset.x + "%", top: newMap.dataset.y + "%"}, 
                    {opacity:1, duration: animSpeed, delay: 0, scale: 1, left: "0%", top:"0%", onStart:()=>{
                        newMap.classList.remove('hns-map_hide');
                    }, 
                    onComplete:()=>{
                        newMap.classList.add('hns-map_active');
                    }}
                );
            });
        }

        // Возврат на уровень 1
        for(let back of document.querySelectorAll('.js-map-back')) {
        
            back.addEventListener("click", (e) => {
                for(let oldMap of maps.querySelectorAll(".hns-map")) {
                    if(oldMap.classList.contains('hns-map_active')) {
                        gsap.fromTo(
                            oldMap, 
                            {opacity:1, scale: 1, left: "0%", top:"0%" }, 
                            {opacity:0, duration: animSpeed, delay: 0, scale: 0.2, left: oldMap.dataset.x + "%", top: oldMap.dataset.y + "%", 
                            onStart:() => {
                            oldMap.classList.remove('hns-map_active'); 
                            },
                            onComplete:()=>{
                                oldMap.classList.add('hns-map_hide');
                                
                            }}
                        );
                    }
                }

                gsap.fromTo(
                    map, 
                    { opacity:0, scale: 4 }, 
                    {opacity:1, duration: animSpeed, delay: 0, scale: 1, 
                    onStart:() => {
                        map.classList.remove('hns-map_hide');
                    } ,
                    onComplete:()=>{
                        map.classList.add('hns-map_active');
                    }}
                );
            })
        }

        // Уровень 2
        for(let mark of maps.querySelectorAll(".js-map-a .mark, .js-map-i .mark")) {
            let currentMap = mark.closest(".hns-map");

            let title_str = currentMap.dataset.title;
            let text_str = currentMap.dataset.text;

            mark.addEventListener('mouseenter', () => {
                title.innerHTML = mark.dataset.title;
                text.innerHTML = mark.dataset.text;
                //cursor.show();
                cursor.setText('Бронировать');
            });

            mark.addEventListener('mouseout', () => {
                title.innerHTML = title_str;
                text.innerHTML = text_str;
                //cursor.hide();
                cursor.removeText();
            });

        }
    }

}